
import { Api } from '@/interface/api';

/**
 * 获取专题赛列表
 * @param accountId
 */
const getRaceSpecials: Api = {
    url: '/api/project/proxy/api/v1/race-specials',
    method: 'get',
};

export { getRaceSpecials };
